/**
 * For regular builds (dev server, production build, etc.):
 * The webpack `DefinePlugin` reads a JSON file from `./env/` and injects it as a global constant at build time.
 *
 * For testing with Jest:
 * The `test/setupEnv.js` file loads the `./env/env.test.json` file and assigns it to a global variable.
 * This allows tests to access the configuration in the same way as the application code.
 *
 * @type {import('../types/config').EnvConfig}
 */
export const envConfig =
  process.env.NODE_ENV === "test" && typeof global !== "undefined" && global.__CS_CONFIG__
    ? global.__CS_CONFIG__
    : process.env.CS_CONFIG;
